import { render, staticRenderFns } from "./LegendBox.vue?vue&type=template&id=dcce9e42&scoped=true"
import script from "./LegendBox.vue?vue&type=script&lang=js"
export * from "./LegendBox.vue?vue&type=script&lang=js"
import style0 from "./LegendBox.vue?vue&type=style&index=0&id=dcce9e42&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcce9e42",
  null
  
)

export default component.exports